export function athleteDisplayName({ givenName, familyName, }) {
    return fullNameDisplay(givenName, familyName);
}
export function athleteInitials({ givenName, familyName, }) {
    const givenInitial = givenName.charAt(0).toUpperCase();
    const familyInitial = familyName.charAt(0).toUpperCase();
    return `${givenInitial}${familyInitial}`;
}
function fullNameDisplay(givenName, familyName) {
    return `${givenName} ${familyName}`;
}
//# sourceMappingURL=utils.js.map